module.exports = __webpack_public_path__ + "static/axie265_circle-81ae234200080d94fa9fa4683260b481.svg";